import { storeAsync } from '@/app-module';

export default {
    async beforeRouteEnter(to, from, next) {
        if (!to.meta || !to.meta.requiresEmailVerification) {
            next();
            return;
        }
        const store = storeAsync();
        await store.dispatch('auth/doWaitUntilInit');

        if (!store.getters['auth/isAuthSucceeded']) {
            next('/auth/signin');
            return;
        }

        if (store.getters['auth/isEmailConfirmed']) {
            next('/');
            return;
        }

        next();
    }
};
